import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/security";
import { HomeComponent } from './modules/home/components/home/home.component'; 
import { TwoFactorSendCodeComponent } from '@modules/account/login/components/twofactor/send-code/send-code.component';
import { TwoFactorVerifyCodeComponent } from '@modules/account/login/components/twofactor/verify-code/verify-code.component';
import { NewPasswordComponent } from '@modules/account/login/components/newpassword/newpassword.component';
import { SendTokenResetPasswordComponent } from '@modules/account/login/components/sendtokennewpassword/send-token-possword.component';
import { ConfirmAccountComponent } from '@modules/account/login/components/confirm-account/confirm-account.component';
import { QuestionSecurityComponent } from '@modules/account/login/components/question-security/question-security.component';
import { LoginComponent } from './modules/account/login/components/login/login.component';
import { ConfirmChangeEmailComponent } from '@modules/account/login/components/confirm-changeEmail/confirm-changeEmail.component';

const appRoutes: Routes = [
  {
    path: '', data: { breadcrumb: 'Accueil' }, canActivate: [AuthGuardService],
    children: [
      { path: '', redirectTo: 'home', pathMatch: "full", data: { breadcrumb: null, breadcrumbVisible: false } },
      { path: 'my-account', data: { breadcrumb: 'Mon compte' }, loadChildren: () => import('./modules/account/edit/account-infos.module').then(m => m.EditMyInfosModule) }, 
      { path: 'Coffre-fort/dist', redirectTo:'home', pathMatch:"prefix"},
      { path: 'home', component: HomeComponent, data: { breadcrumb: null, breadcrumbVisible: false }, canActivate: [AuthGuardService] },
      { path: 'my-account', data: { breadcrumb: 'Mon compte' }, loadChildren: () => import('./modules/account/edit/account-infos.module').then(m => m.EditMyInfosModule) },
      { path: 'FichesPaie', data: { breadcrumb: 'Mes fiches de paie' }, loadChildren: () => import('./modules/coffre-fort/coffre-fort.module').then(m => m.CoffreFortModule) },
      { path: 'HistoriqueActivation', data: { breadcrumb: 'Historiques d\'activation' }, loadChildren: () => import('./modules/historique-activation/historique-activation.module').then(m => m.HistoriqueActivationModule) },
      { path: 'BulletinsSalaire', data: { breadcrumb: 'Approbation' }, loadChildren: () => import('./modules/bulletin-salaire/bulletin-salaire.module').then(m => m.BulletinSalaireModule) },
      { path:'help',data:{breadcrumb:"Manuel d'utilisation"},loadChildren:()=> import('./modules/help/help.module').then(m=>m.HelpModule)}
     ]
  },
  { path: 'Home/Coffre-fort/dist', redirectTo: '', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'login/send-code', component: TwoFactorSendCodeComponent },
  { path: "login/verify-code", component:TwoFactorVerifyCodeComponent },
  { path: "account/ResetPassword", component:NewPasswordComponent },
  { path: "lostPassword", component: SendTokenResetPasswordComponent },
  { path:"account/confirmEmail", component:ConfirmAccountComponent},
  { path:"account/securityQuestion", component:QuestionSecurityComponent},
  { path:"account/confirmUpdateEmail", component:ConfirmChangeEmailComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
